module.exports = __webpack_public_path__ + "static/img/about-citys.ca09e10.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/web/about-citys.jpg
// module id = aa0x
// module chunks = 0